export default {
  data: () => ({
    apiRouteList: null,
    items: [],
    _search: "",
    loading: {
      list: false,
      refresh: false,
      filter: false,
      export: false
    },
    pagination: {
      sortBy: "p_id",
      page: 1,
      rowsPerPage: 10,
      descending: true
    },
    filters: {},
    meta: {
      total: null
    },
    dialogFilter: {
      show: false
    },
    rowPerPageItems: [10, 20, 50]
  }),
  created() {
    this.$store.dispatch("setNotification", { status: false });
  },
  watch: {
    pagination: {
      handler() {
        this.getItems();
      }
    }
  },
  methods: {
    filterItemsModal() {
      this.dialogFilter.show = true;
    },
    getItems() {
      let self = this;
      return new Promise((resolve, reject) => {
        if (!self.apiRouteList) {
          resolve();
          return;
        }

        self.loading.list = true;
        self.$store
          .dispatch("request", {
            url: self.apiRouteList,
            options: {
              params: self.getParamsQuery()
            }
          })
          .then(response => {
            self.items = response.data.items;
            self.meta = response.data.meta;
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
          .then(() => {
            self.loading.list = false;
          });
      });
    },
    refreshItems() {
      let self = this;
      self.loading.refresh = true;

      this.getItems()
        .then()
        .catch()
        .then(() => {
          self.loading.refresh = false;
        });
    },
    filterItems(filters) {
      let self = this;
      let search = "";
      this._.each(filters, (filter) => {
        if(!filter.value) return;
        search += search ? "," : search;
        search += filter.field + "::" + filter.op + "::" + filter.value.trim();
      });
      this._search = search;

      this.loading.filter = true;
      this.getItems()
        .then(() => {})
        .catch(() => {})
        .then(() => {
          self.loading.filter = false;
        });
    },
    getParamsQuery() {
      let current = {
        page: this.pagination.page,
        limit: this.pagination.rowsPerPage
      };

      if (this._search) {
        current._search = this._search;
      }

      let params = this.getQueryParams();

      return Object.assign({}, current, params);
    },
    getQueryParams() {
      return {};
    },
    search: function() {
      this.getItems();
    }
  }
};
